import * as React from 'react';

import Hidden16 from './Hidden16';

export const hidden16 = () => <Hidden16 />;

export default {
    title: 'Icon/Line/Hidden16',
    component: Hidden16,
    parameters: {
        notes: "`import Hidden16 from 'box-ui-elements/es/icon/line/Hidden16';`",
    },
};
